module.exports = __webpack_public_path__ + "img/hero-earth-01.0b833b77.png";